import { render } from "./CheckIcon12.vue.js?vue&type=template&id=28da311c!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./CheckIcon12.vue?vue&type=template&id=28da311c"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__